import { render } from "./PuestoForm.vue?vue&type=template&id=107703d0&scoped=true"
import script from "./PuestoForm.vue?vue&type=script&lang=js"
export * from "./PuestoForm.vue?vue&type=script&lang=js"

import "./PuestoForm.vue?vue&type=style&index=0&id=107703d0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-107703d0"]])

export default __exports__